// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b871b0a8","900":"96315c52"}[chunkId] + ".chunk.js";
};